<template>
  <q-page padding>
    <PageHeader
      title="Criar de Usuario"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <div class="row col-12 q-gutter-sm q-mt-md text-brand-5 text-weight-bold">
      <div class="col-md col-xs-6">
        <div>Unidade</div>
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-md col-xs-5">
        <div>Nome</div>
        <q-input
          ref="inputRef"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          label="Nome"
          dense
          outlined
          v-model="dados.nome"
          hide-bottom-space
        />
      </div>
      <div class="col-md col-xs-6">
        <div>Matricula</div>
        <q-input
          ref="inputRef2"
          label="Matricula, Sap, RE, ID ou outro identificado único"
          dense
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          @keyup="conexaoEmail"
          v-model="dados.id"
          hide-bottom-space
        />
      </div>
      <div class="col-md col-xs-6">
        <div>Email</div>
        <q-input
          ref="inputRef3"
          label="Email corporativo válido"
          dense
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          v-model="dados.email"
          hide-bottom-space
        />
      </div>
      <div class="col-md col-xs-6">
        <div>Centro de Custo</div>
        <q-select
          label="Centro de Custo"
          dense
          outlined
          v-model="dados.centroCusto"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          hide-bottom-space
          use-input
          input-debounce="500"
          @filter="filtrarCentro"
          :options="options.centros"
          :option-label="
            (opt) =>
              Object(opt) === opt && 'name' in opt
                ? opt.code + ' - ' + opt.name
                : ''
          "
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-italic text-grey">
                Nenhum centro de custo encontrado
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
      <div class="col-md col-xs-6">
        <div>GHE</div>
        <q-select
          outlined
          dense
          v-model="dados.ghe"
          :options="funcoes"
          option-value="id"
          behavior="menu"
          map-options
          label="Digite o GHE"
          use-input
          option-label="name"
          @filter="filtrarGhe"
        >
        </q-select>
      </div>

      <div>
        <p></p>
        <q-btn
          icon="add"
          no-caps
          class="q-mt-sm"
          color="positive"
          label="Criar Usuario"
          @click="criarUsuario"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();
    const unidade = ref();
    const dados = ref({
      nome: "",
      id: "",
      email: "",
      centroCusto: "",
      ghe: "",
    });
    const options = ref({ centros: [] });
    const funcoes = ref([]);

    const inputRef = ref(null);
    const inputRef2 = ref(null);
    const inputRef3 = ref(null);

    const criarUsuario = async () => {
      for (const vazios in dados.value) {
        if (dados.value[vazios] == "" && vazios != "ghe") {
          quasar.notify({
            message: "Preencha todos os campos",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }

      try {
        let response = await store.dispatch("user/criarUsuario", {
          vendor_id: store.state.org.unidadeData.id,
          name: dados.value.nome,
          sap: dados.value.id,
          email: dados.value.email,
          cost_center_id: dados.value.centroCusto.id,
          function_id: dados.value?.ghe?.id,
        });

        quasar.notify({
          message: "Usuario criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        for (const vazios in dados.value) {
          dados.value[vazios] = "";
        }

        await inputRef.value.resetValidation();
        await inputRef2.value.resetValidation();
        await inputRef3.value.resetValidation();

        router.push({
          name: "usuario-editar",
          params: { id: response.data.model.id },
        });
      } catch (error) {
        if (
          error.response.data.errors.sap &&
          error.response.data.errors.sap[0] ===
            "The sap has already been taken."
        ) {
          quasar.notify({
            message: "Já existe um usuário com está matricula.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }

        if (
          error.response.data.errors.email &&
          error.response.data.errors.email[0] ===
            "The email has already been taken."
        )
          quasar.notify({
            message: "Esse email ja esta sendo utilizado",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

        quasar.notify({
          message: "Erro ao criar usuário.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarCentroCusto = async (val) => {
      options.value.centros = [];
      try {
        const response = await store.dispatch("user/getCentros", {
          search: val,
          vendor_id: store.state.org.unidadeData.id,
        });
        options.value.centros = response.data.results.data;
      } catch (error) {
        console.log(error);
      }
    };

    const getFunctions = async (value) => {
      let response = await store.dispatch("user/getFuncoes", {
        vendor_id: store.state.org.unidadeData.id,
        search: value,
      });
      funcoes.value = response.data.results.data;
    };

    const conexaoEmail = async () => {
      let subdomain = window.location.host.split(".")[1]
        ? window.location.host.split(".")[0]
        : false;

      dados.value.email = dados.value.id;
      dados.value.email = `${dados.value.email}@${subdomain}.com.br`;
      if (dados.value.id == "") {
        dados.value.email = "";
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      dados,
      criarUsuario,
      conexaoEmail,
      inputRef,
      inputRef2,
      listarCentroCusto,
      filtrarCentro(val, update) {
        listarCentroCusto(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      options,
      inputRef3,
      unidade,
      filtrarGhe(val, update) {
        getFunctions(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      funcoes,
    };
  },
};
</script>
